import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import PageLayout from '@/components/cms/page-layout'
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import { Icons, CustomLinkComponent, MainWrapper } from 'msp-components'
import * as S from './partials/PosStart.styles'
import Teaser from './partials/Teaser'
import AgentIdModal from './partials/AgentIdModal'

const PosStart = () => {
  const { formatMessage } = useIntl()
  const [agentModalOpen, setAgentModalOpen] = useState<boolean>()

  useEffect(() => {
    setAgentModalOpen(true)
  }, [])

  const teasers: Teaser[] = [
    {
      imgSrc: getAssetUrl('static/img/posteaser-1.jpg'),
      text: formatMessage({
        defaultMessage: 'bestellung anlegen',
        id: 'msp.pos_start.teaser1'
      }),
      href: '/shop'
    },
    {
      imgSrc: getAssetUrl('static/img/posteaser-2.jpg'),
      text: formatMessage({
        defaultMessage: 'service & kontakt',
        id: 'msp.pos_start.teaser2'
      }),
      href: '/service'
    },
    {
      imgSrc: getAssetUrl('static/img/posteaser-3.jpg'),
      text: formatMessage({
        defaultMessage: 'about avoury & video',
        id: 'msp.pos_start.teaser3'
      }),
      href: '/about'
    }
  ]

  return (
    <div className={S.pageContainer}>
      <MainWrapper>
        <AgentIdModal
          isOpen={agentModalOpen}
          onClose={() => setAgentModalOpen(false)}
        />
        <div className={S.backdropWrapper}>
          <div className={S.backdropHeader}>
            <span className={S.iconWrapper}>
              <Icons
                iconName='JasminLogo'
                width='396px'
                height='60px'
                color='black'
              />
            </span>
            <h4 className={S.headerTitle}>
              {formatMessage({
                defaultMessage: 'Point of Sale',
                id: 'msp.pos_start.title'
              })}
            </h4>
          </div>
          <div className={S.teaserContainer}>
            {teasers.map(({ imgSrc, text, href }, idx) => (
              <Teaser
                key={`teaser_${idx}`}
                imgSrc={imgSrc}
                text={text}
                href={href}
              />
            ))}
          </div>
          <div className={S.welcomeOfferLinkWrapper}>
            <CustomLinkComponent
              href='/welcome-package'
              className={S.welcomeOfferLink}
              colorScheme='primary'
              uppercase
            >
              {formatMessage({
                defaultMessage: 'Welcome Offer',
                id: 'msp.pos_start.welcome_offer_link'
              })}
            </CustomLinkComponent>
          </div>
        </div>
      </MainWrapper>
    </div>
  )
}

const PosStartWrapper = (props: any) => (
  <PageLayout {...{ ...props, ChildPage: PosStart }} />
)

export default PosStartWrapper
